import React from 'react';
import GenioLeadsFaq from './GenioLeadsFaq';

function genioLeads() {
  return (
    <>
      {/* <FaqHeader
        selectedType="business"
        selectedBusiness={selectedBusinessData}
        id="leads"
        trackerId="home"
        projectId="genio"
        setToastMsg={setToastMsg}
      /> */}
      <GenioLeadsFaq />
    </>
  );
}

export default genioLeads;
